import { useContext, useEffect, useState } from 'react'
import { DataContainer } from '../../../pages/report-page/report-page-styles'
import { ReportingContext } from '../../../contexts/reporting-context'

import { FullCapacityBooking } from './full-capacity-booking/full-capacity-booking-card'
import { MostPopularDay } from './most-popular-day/most-popular-day-card'
import { TotalBooking } from './total-bookings/total-bookings-card'
import { MostVisitingTeam } from './most-visiting-team/most-visiting-team-card'

const ReportingCard = () => {
  const { reportTeam } = useContext(ReportingContext)
  const [showAllCards, setShowAllCards] = useState(true)

  useEffect(() => {
    if (reportTeam) {
      setShowAllCards(reportTeam.id === 'all-teams')
    }
  }, [reportTeam, setShowAllCards])

  return (
    <DataContainer>
      <TotalBooking />
      <MostPopularDay />
      {showAllCards && (
        <>
          <MostVisitingTeam />
          <FullCapacityBooking />
        </>
      )}
    </DataContainer>
  )
}

export default ReportingCard
